let isBodyScrollEnabled = true;
let savedScrollPosition = 0;
export const enableBodyScroll = () => {
  if (isBodyScrollEnabled) return;
  document.body.classList.remove('disable-scroll');
  document.body.style.top = '';
  window.scrollTo(window.pageXOffset, savedScrollPosition);
  isBodyScrollEnabled = true;
};
export const disableBodyScroll = () => {
  if (!isBodyScrollEnabled) return;
  savedScrollPosition = window.pageYOffset;
  document.body.classList.add('disable-scroll');
  window.scrollTo(window.pageXOffset, 0);
  document.body.style.top = `${-1 * savedScrollPosition}px`;
  isBodyScrollEnabled = false;
};
export const makeBodyHeightAuto = () => document.body.classList.add('h-auto');
export const unmakeBodyHeightAuto = () => document.body.classList.remove('h-auto');